<template>
  <div class="main" v-title data-title="Bonus dollars!">
    <div class="main-box">
      <div class="main-bg">
        <img class="top-icon-bg" src="../img/icon_top.png">
      </div>
      <div class="top-icon">
        <div class="share_title" :class="$i18n.locale">
          <span v-if="log">{{$i18n.locale}}<br></span>
          {{ $t('share_title') }}</div>
      </div>
      <div class="top-ribbon">
        <img class="top-icon-title" src="../img/ribbon.png">
      </div>
      <div class="center-box">
        <div class="reward_title center">
          <span class="info" :class="$i18n.locale">{{ $t('share_info').replace("{count}", '$'+active_count) }}</span>
        </div>
        <div class="reward">
          <img class="reward-card" src="../img/reward_bg.png">
          <div class="reward-center center-space-between">
            <div class="reward-left">
              <div class="reward-install-info center">
                <div class="reward-install-box" :class="$i18n.locale" v-html="$t('install_info').replace('{name}', '<b>'+productName+'</b>')"></div>
              </div>
              <div class="reward-amount" @click="testLanguage">{{ active_count.toFixed(2) }}</div>
              <div class="reward-time">{{ countdownStr }}</div>
            </div>
          </div>
        </div>

        <div class="btn-dow-pos btn-dow center btn-anim" @click="download">
          <span class="title">{{ $t('install_btn')}}</span>
          <div class="dot center bubble-anim"><span>${{ active_count }}</span></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// 保存模块
let Base64 = require('js-base64').Base64;
let layer = require('layer-mobile');
let qs = require('qs');
let md5 = require('md5');
export default {
  data() {
    return {
      log: process.env.VUE_APP_LOG,
      json: {},
      isTest: '',
      countdown: 300,//5分钟
      countdownStr: '00:00:00',
      active_count: 6,
      productName: 'Disco Ball',
      productList: {
        210: "Ball",
        526: "Lucky Party",
        556: "Lucky Drop",
        550: "Crazy Pusher",
        592: "Hyper Pusher",
        572: "Lucky Bingo",
        573: "Bingo Now",
        576: "Magic Dice",
        568: "Dropping Ball",
        581: "Dropping Ball2",
        588: "Disco Ball",
        590: "Dozer Mania",
      },
      isAutoDow: true,
      isLoadings: false,
      cache_start_time: 0,
      cache_end_time: 0,
      languageIndex: 0,
    }
  },
  name: 'Home',
  props: {
    msg: String
  },
  mounted() {
    let _this = this;
    this.initData();
    this.timer = setInterval(() => {
      // eslint-disable-next-line no-undef
      _this.countdownStr = util.formatTime(_this.countdown, "hh:mm:ss");
      _this.countdown--;
      if (_this.countdown < 0) {
        _this.countdown = 5 * 60;
      }
    }, 1000)
  },
  computed: {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    testLanguage() {
      if (this.log){
        let list = [];
        for (const indexKey in this.$i18n.messages) {
          list.push(indexKey)
        }
        let index = this.languageIndex % list.length;
        this.$i18n.locale = list[index]
        this.languageIndex++;
      }
    },
    initData() {
      let self = this;
      var conf = this.getRequest(window.location.href);
      if (conf === undefined) {
        self.layer('无参数', 3);
        return;
      }
      let dataStr = false;
      try {
        dataStr = Base64.decode(conf);
      } catch (e) {
        console.log('No parameters');
        self.layer('解析base64失败-' + dataStr, 3);
        return;
      }
      if (!dataStr) {
        return;
      }
      try {
        self.json = JSON.parse(dataStr);
      } catch (e) {
        console.log('str to json err');
      }
      console.log(self.json);
      self.stats('s_h5');

      // 初始化名字
      let productName = self.productList[self.json.product_id];
      if (productName !== undefined) {
        self.productName = productName;
      }

      //增加name接口的内容
      let appName = self.json.app_name;
      if (typeof appName == "string" && appName.length > 0) {
        self.productName = appName;
      }

      //增加金额的内容
      let active_count = self.json.active_count;
      if (typeof active_count == "number" && appName.length > 0) {
        self.active_count = active_count;
      }
    },
    download() {
      this.stats('c_h5_button');
      if (typeof this.json.url != "undefined") {
        window.location = this.json.url;
      }
    },
    getTime() {
      return (new Date().getTime() / 1000).toFixed(0);
    },
    getRequest(urlStr) {
      let url = "";
      if (typeof urlStr == "undefined") {
        url = decodeURI(location.search); //获取url中"?"符后的字符串
      } else {
        url = "?" + urlStr.split("?")[1];
      }
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        module.exports
        theRequest = url.substr(1);
      }
      return theRequest;
    },
    layer(content, time) {
      let self = this;
      if (isNaN(time)) {
        time = 2;
      }
      if (self.isTest) {
        console.log(content, time)
        //提示
        layer.open({content: '测试-' + content, skin: 'msg', time: time});
      }
    },
    // eslint-disable-next-line no-unused-vars
    stats(keyStr, par1) {
      let self = this;
      const tims = self.getTime();
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let language = (navigator.browserLanguage || navigator.language).toLowerCase();
      if (isNaN(par1)) {
        par1 = 0;
      }
      let request_data = [
        {
          "product_id": self.json.product_id,
          "uuid": self.json.uuid,
          "time_stamp": tims,
          "package_name": "com.staaa",
          "country": language,
          "media_source": "other",
          "campaign": "other_campaign",
          "version_code": 1,
          "version_name": "1.0",
          "google_aid": "4567-8901-3344-5678",
          "stats_sdk_version": "0.1",
          "install_days": 1,
          "is_upgrade_user": 1,
          "process_uuid": "abc-efg-uvw-xyz-c",
          "os": isiOS ? 2 : 1,
          "os_version": "8.0",
          "os_language": language,
          "phone_model": "phone_model",
          "net": "WIFI",
          "memory": 2,
          "dpi": 50,
          "screen_wh": document.body.clientWidth + "x" + document.body.clientHeight,
          "screen_inchu": "4.9",
          "imei": "123456789",
          "imsi": "987654321",
          "src": 513,
          "event": keyStr,
          "eb_key1": par1,
          "eb_key2": 0,
        }
      ];
      if (keyStr == 'show_apkweb') {
        request_data[0]["productID"] = self.json.product_id;
        request_data[0]["userID"] = self.json.uuid;
      }

      //签名加密
      const key = 'L9gh=p%Eozfn2#@';
      const request_data_str = JSON.stringify(request_data);
      const sign = md5(key + request_data_str + key + tims + key);
      let obj = {
        request_data: request_data_str,
        timestamp: tims,
        sign: sign,
      }

      // const url = 'http://192.168.1.76/stats/collect?sign=Jhdgh_fasgl1_a)1sfs';
      const url = 'https://n12.smartmobitec.com/service_stats/v3/collect';
      self.$axios.post(url, qs.stringify(obj))
          .then(function (response) {
            let data = response.data;
            if (data) {
              console.log('统计成功', keyStr, par1)
            }
          })
          .catch(function (error) {
            console.log(error.data);
          });
    }

  }
}


</script>

<style scoped>

</style>
